import React from 'react';
import { useHistory } from 'react-router-dom';
import './Access-Denied.scss';

const AccessDenied = () => {
  const history = useHistory();

  const onHomeClick = () => {
    history.push('/');
  };

  return (
    <div className='row d-flex justify-content-center align-items-center mb-3 content mx-0 access-denied'>
      <div className='header-row d-flex justify-content-center'>
        <span className='app-greeting ms-1'>403 - Access Denied</span>
      </div>
      <div className='col-md-12 d-flex justify-content-center'>
        <span
          className='home-link'
          onClick={(e) => {
            onHomeClick();
          }}
        >
          Back to Home
        </span>
      </div>
    </div>
  );
};

export default AccessDenied;
